<div>
    <div class="vw-container">
        <div class="vw-row">
            <p-carousel [value]="cars" [numVisible]="3" [numScroll]="1">
                <ng-template let-car pTemplate="item">
                    <span class="carousel-text"> {{car}} </span>
                    <br />
                    <div class="top-car-box">
                        <img src="assets/images/Polo.png" alt="car image" style="width:300px;">
                    </div>
                </ng-template>
            </p-carousel>
        </div>
    </div>
</div>

<jw-modal id="custom-modal-1">
    <h1>A Custom Modal Window!</h1>
    <p>Home page text: Test</p>
    <!-- <button (click)="closeModal('custom-modal-1');">Close</button> -->
</jw-modal>

<br />
<button (click)="openModal('custom-modal-1')">Open Modal 1</button>